export default __webpack_public_path__ + "static/media/twelve.64a7793d.svg";